import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../app/core/common/common.service';
import { ProductOption } from '../../types/program-types';
import { SubmissionStartChoiceComponent } from '../../submission-start-choice.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-au-gold',
  standalone: true,
  imports: [],
  templateUrl: './au-gold.component.html',
  styleUrl: './au-gold.component.scss'
})
export class AuGoldComponent {
  /** Set by the parent (SubmissionStartChoiceComponent) when this modal is opened. */
  @Input() public selectedProduct: ProductOption | null = null;
  contactEmail = 'info@greenshieldrisk.com';

  // private readonly auGoldPortalUrl = 'https://login.augold.net/login';
  private readonly auGoldPortalUrl = environment.auGoldURL;
  
  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly commonService: CommonService,
    private readonly modalService: NgbModal
  ) { }

  public back(): void {
    this.activeModal.dismiss('cancel');
    this.openSubmissionStartChoice();
  }

  public cancel(): void {
    this.activeModal.dismiss('cancel');
  }

  public openAuGoldPortal(): void {
    this.commonService.setSkipDirtyGuard(true);
    window.open(this.auGoldPortalUrl, '_blank', 'noopener,noreferrer');
    this.activeModal.dismiss('cancel');
  }
  private openSubmissionStartChoice(): void {
      const submissionModal: NgbModalRef = this.modalService.open(SubmissionStartChoiceComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
        windowClass: 'submission-start-modal',
        keyboard: false,
      });
        submissionModal.componentInstance.selected = this.selectedProduct?.id ?? null;

}
}
